var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification_users" },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                on: { click: _vm.select_user },
              },
              [
                _c("span", { staticClass: "fal fa-eject mr-1" }),
                _vm._v("\n                Обрати користувачів\n            "),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.doc.id > 0
            ? _c("b-col", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-md btn-block btn-outline-success waves-effect waves-themed",
                    attrs: { disabled: _vm.selected_users.length === 0 },
                    on: { click: _vm.send_notification },
                  },
                  [
                    _c("span", { staticClass: "fal fa-eject mr-1" }),
                    _vm._v("\n                Повідомлення\n            "),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "users_in" }, [
        _vm.doc.id > 0
          ? _c("div", {}, [
              _c("div", { staticClass: "panel-tag mt-2 mb-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-group btn-group-sm btn-group-toggle",
                    attrs: {
                      id: "js_change_tab_direction",
                      "data-toggle": "buttons",
                    },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "btn btn-primary active waves-effect waves-themed cursor-pointer",
                        attrs: {
                          "data-action": "",
                          "data-class": "n",
                          "data-target": "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.check_uncheck(true)
                          },
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: "radioNameTabDirection",
                            checked: "",
                            value: "nav nav-tabs",
                          },
                        }),
                        _vm._v(" Обрати Всі\n                    "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "btn btn-success waves-effect waves-themed cursor-pointer",
                        attrs: {
                          "data-action": "",
                          "data-class": "",
                          "data-target": "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.check_uncheck(false)
                          },
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: "radioNameTabDirection",
                            value: "nav nav-tabs justify-content-end",
                          },
                        }),
                        _vm._v(" Зняти виділення\n                    "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "badge badge-primary float-right" }, [
                  _vm._v(
                    "В списку " +
                      _vm._s(_vm.selected_users.length) +
                      " користувачів "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "users_list mt-3" }, [
          _c(
            "ul",
            { staticClass: "user_list_to_insert" },
            _vm._l(_vm.inside_users, function (item, index) {
              return _c(
                "li",
                {
                  staticClass: "border cursor-pointer shadow-1 mt-1 mb-2",
                  class: _vm.user_class(item),
                  on: {
                    click: function ($event) {
                      return _vm.select_user_notification(item)
                    },
                  },
                },
                [
                  _c("user_block", {
                    key: item.id,
                    attrs: {
                      del_triger: "remove_customer_in_invoice",
                      can_del: true,
                      show_vacation: true,
                      user: item,
                      padding_class: "pt-2 pl-2 pb-1",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }